<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">To my parents for my education,</p><br/>
<p style="text-align: center;">To everyone I love,</p><br/>
<p style="text-align: center;">Lost,</p><br/>
<p style="text-align: center;">And am still leaving.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?bc8e27ca